import { type RefObject, useEffect, useState } from 'react';

/**
 * Detects whether a horizontally-scrollable container has overflow content
 * to the right, enabling fade gradient indicators.
 */
export function useScrollOverflow(ref: RefObject<HTMLElement | null>): {
  canScrollRight: boolean;
} {
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = (): void => {
      setCanScrollRight(el.scrollWidth > el.clientWidth + el.scrollLeft + 2);
    };

    check();
    el.addEventListener('scroll', check, { passive: true });
    const mo = new MutationObserver(check);
    mo.observe(el, { childList: true, subtree: true });
    const ro = new ResizeObserver(check);
    ro.observe(el);

    return () => {
      el.removeEventListener('scroll', check);
      mo.disconnect();
      ro.disconnect();
    };
  }, [ref]);

  return { canScrollRight };
}
